import { useApi, createApiHook } from "../utils/apiUtils";

const useCreateInstrument = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const createInstrument = async (payload) => {
    startLoading();
    const response = await apiPost("/instruments", "Error al crear el instrumento", payload);
    setResponse(response);
    return response;
  };

  return { createInstrument, data, error, loading };
};

export default useCreateInstrument;
